module.exports = __webpack_public_path__ + "static/media/noProduct.d761a4ac.svg";